import { render } from "./PlotSpecsEditing.vue?vue&type=template&id=45fda712&ts=true"
import script from "./PlotSpecsEditing.vue?vue&type=script&lang=ts"
export * from "./PlotSpecsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__